import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { SwapHoriz } from '@mui/icons-material';
import { apiService } from '../services/api';
import TwoTeamsTrade from '../components/TwoTeamsTrade';

interface TeamMapping {
  id: number;
  name: string;
  colors: {
    primary: string;
    secondary: string;
  };
}


const TradeAnalysis: React.FC = () => {
  const [teamMappings, setTeamMappings] = useState<{ [key: string]: TeamMapping }>({});
  const [loadingMappings, setLoadingMappings] = useState(true);


  // Fetch team mappings on mount
  useEffect(() => {
    apiService.getTeamMappingsV2() // Using V2 API
      .then((data) => {
        // Transform V2 response to match V1 format (keyed by team short name)
        const transformedMappings: { [key: string]: TeamMapping } = {};
        data.team_mappings.forEach((mapping: any) => {
          // Use team short name (e.g., "RR", "MI") as key, like V1
          const teamShortName = mapping.team_name; // Short code like "GT"
          transformedMappings[teamShortName] = {
            id: mapping.team_id,
            name: mapping.team_full_name || mapping.team_name, // Full name like "Gujarat Titans"
            colors: {
              primary: mapping.team_color,
              secondary: mapping.team_color
            }
          };
        });
        setTeamMappings(transformedMappings);
        setLoadingMappings(false);
      })
      .catch((error) => {
        console.error('Error fetching team mappings:', error);
        setLoadingMappings(false);
      });
  }, []);


  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Box sx={{ mb: 4, mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <SwapHoriz color="primary" fontSize="large" />
            Trade Machine
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            Evaluate player trades and their impact on team performance
          </Typography>
        </Box>
      </Box>

      {/* Two-teams trade is the Trade Machine (multi-team may return later) */}
      {loadingMappings ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading team data...
          </Typography>
        </Box>
      ) : (
        <TwoTeamsTrade teamMappings={teamMappings} />
      )}
    </Container>
  );
};

export default TradeAnalysis;
